"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _orderItemCardModule = _interopRequireDefault(require("./orderItemCard.module.scss"));

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _reactClampLines = _interopRequireDefault(require("react-clamp-lines"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var OrderItemCard = function OrderItemCard(_ref) {
  var actionButtons = _ref.actionButtons,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      items = _ref.items,
      notes = _ref.notes,
      price = _ref.price,
      title = _ref.title;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views,
      buttons = _useTemplate$useCell.buttons;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    dataTest: dataTest,
    type: views.background,
    Component: "li",
    className: [_orderItemCardModule["default"].orderItem, "order-item"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _orderItemCardModule["default"]["orderItem-info"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _orderItemCardModule["default"]["orderItem-info-title"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary,
    className: _orderItemCardModule["default"]["orderItem-info-name"],
    role: "heading",
    "aria-level": "3",
    "aria-label": title
  }, /*#__PURE__*/_react["default"].createElement(_reactClampLines["default"], {
    id: "0",
    buttons: false,
    text: title,
    lines: 1,
    ellipsis: "..."
  })), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _orderItemCardModule["default"]["orderItem-info-price"]
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.secondary,
    className: _orderItemCardModule["default"]["orderItem-info-desc"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _orderItemCardModule["default"]["orderItem-info-desc-mods"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: items.length
  }, items.map(function (_ref2, index) {
    var name = _ref2.name,
        price = _ref2.price;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      type: labelTextStyles.tertiary
    }, name, " ", price));
  })), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: notes
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary
  }, "Note: ".concat(notes)))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: actionButtons.length
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _orderItemCardModule["default"]["orderItem-info-desc-actions"]
  }, actionButtons.map(function (_ref3, index) {
    var content = _ref3.content,
        type = _ref3.type,
        action = _ref3.action;
    return /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
      key: index,
      type: buttons[type],
      className: _orderItemCardModule["default"]["orderItem-btn"],
      onClick: action
    }, content);
  }))))));
};

var _default = OrderItemCard;
exports["default"] = _default;